export const state = () => ({
  alert: null,
  toasterMsgs: []
})

let nextMessageId = 1

const getters = {
  lastToasterMsgId: (state) => {
    return getLastMsgId(state.toasterMsgs)
  }
}

const mutations = {
  PUSH_ALERT(state, { show = true, type = 'danger', title = '', content = '', link = null } = {}) {
    state.alert = {
      show,
      type,
      title,
      content,
      link
    }
  },
  ADD_CONTENT_TO_ALERT(state, content) {
    if (typeof state.alert.content === 'string') {
      state.alert.content = [state.alert.content, content]
    } else if (Array.isArray(state.alert.content)) {
      state.alert.content.push(content)
    } else {
      throw new Error('Unexpected and false notifications/alert.content.')
    }
  },
  ADD_LINK_TO_ALERT(state, { href, title }) {
    if (!state.alert) {
      return
    }

    state.alert.link = { href, title }
  },
  SHOW_ALERT(state, show) {
    if (state.alert) {
      state.alert.show = show
    }
  },
  DELETE_ALERT(state) {
    state.alert = null
  },
  PUSH_TOAST(state, { autohide = 10000, type = 'warning', title = '', content = '', id = null } = {}) {
    state.toasterMsgs.push({
      autohide,
      type,
      title,
      content,
      id: id ? id : nextMessageId++
    })
  },
  DELETE_TOAST(state, msgId) {
    const i = state.toasterMsgs.findIndex((msg) => {
      return msg.id === msgId
    })
    if (i >= 0) {
      state.toasterMsgs.splice(i, 1)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions: {},
  mutations
}

// private
function getLastMsgId(msgs) {
  const l = msgs.length
  if (l < 1 || !msgs[l - 1]) {
    return null
  } else {
    return msgs[l - 1].id
  }
}
